import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';
import * as AccessManagement from '../models/AccessManagement';

interface RequestFunctionAction {
    type: 'REQUEST_ACCESSMANAGEMENT';
    version: number;
}

interface ReceiveFunctionAction {
    type: 'RECEIVE_ACCESSMANAGEMENT';
    model: AccessManagement.ResponseAccessManagement;
    version: number;
}

type KnownAction = RequestFunctionAction | ReceiveFunctionAction

export const actionCreators = {
    requestFunctionAccessManagement: (version: number, method: string, body: AccessManagement.AccessManagement, app_id: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();

        if (appState && appState.accessManagement && method === "GET") {

            fetch(`/v1/access-management?app_id=` + app_id, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                },
            })
                .then(response => response.json() as Promise<AccessManagement.ResponseAccessManagement>)
                .then(data => {
                    dispatch({ type: 'RECEIVE_ACCESSMANAGEMENT', model: data, version: version + 2 });
                })
                .then(error => {
                    dispatch({ type: 'REQUEST_ACCESSMANAGEMENT', version: version + 1 });
                });
        }

        if (appState && appState.file && method === "POST") {
            console.log(localStorage.getItem('DMS_APPLICATION'))
            fetch(`/v1/access-management`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then(response => response.json() as Promise<AccessManagement.ResponseAccessManagement>)
                .then(data => {
                    dispatch({ type: 'RECEIVE_ACCESSMANAGEMENT', model: data, version: version + 3 });
                })
                .then(error => {
                    dispatch({ type: 'REQUEST_ACCESSMANAGEMENT', version: version + 1 });
                });
        }

        if (appState && appState.file && method === "PUT") {

            fetch(`/v1/access-management`, {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('DMS_APPLICATION'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then(response => response.json() as Promise<AccessManagement.ResponseAccessManagement>)
                .then(data => {
                    dispatch({ type: 'RECEIVE_ACCESSMANAGEMENT', model: data, version: version + 4 });
                })
                .then(error => {
                    dispatch({ type: 'REQUEST_ACCESSMANAGEMENT', version: version + 1 });
                });
        }
    },
};

const unloadedState: AccessManagement.AccessManagementState = { isLoading: false, response: undefined, version: 0 };

export const reducer: Reducer<AccessManagement.AccessManagementState> = (state: AccessManagement.AccessManagementState | undefined, incomingAction: Action): AccessManagement.AccessManagementState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_ACCESSMANAGEMENT':
            return {
                isLoading: false,
                version: action.version
            };
        case 'RECEIVE_ACCESSMANAGEMENT':
            return {
                isLoading: true,
                response: action.model,
                version: action.version
            };

        default: return state;
    }
};